import { DEFAULT_INITIAL_SETTINGS } from './constants/initial-settings'
import { onAdd, onRemove } from './utils/class-list'
import { onSelect } from './utils/dom'
import Lenis from '@studio-freight/lenis'

const OPTIONS_LENIS = {
  ['OPTIONS_HOME']: {
    duration: 2,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
    smooth: true,
    direction: 'vertical',
  },
  ['OPTIONS_DEFAULT']: {
    duration: 1.4,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)), // https://easings.net
    smooth: true,
    direction: 'vertical',
  },
}

const LENIS_SCROLL_GLOBAL = new Lenis(OPTIONS_LENIS[TEMPLATE_PAGE])

const onInitLenis = (lenisInit) => {
  function raf(time) {
    lenisInit.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
}

onInitLenis(LENIS_SCROLL_GLOBAL)

/**
 * * onDirectionScroll
 */
const SCROLL_DIRECTION = {
  scrollPos: 0,
  direction: 1,
}
const onDirectionScroll = () => {
  if (document.body.getBoundingClientRect().top > SCROLL_DIRECTION.scrollPos) SCROLL_DIRECTION.direction = 1
  else SCROLL_DIRECTION.direction = -1

  SCROLL_DIRECTION.scrollPos = document.body.getBoundingClientRect().top
}

const onDetectScrollDirection = (callbacks = { notScroll: {}, scrollDown: {}, scrollUp: {} }) => {
  let currentScrollY = window.scrollY

  if (typeof onDetectScrollDirection.oldScrollY === 'undefined') {
    onDetectScrollDirection.oldScrollY = currentScrollY
    // if (callbacks.notScroll !== undefined) callbacks.notScroll()
    callbacks.notScroll()

    return 'not scrolling'
  } else if (currentScrollY == onDetectScrollDirection.oldScrollY) {
    // if (callbacks.notScroll !== undefined) callbacks.notScroll()
    callbacks.notScroll()

    return 'not scrolling'
  } else if (currentScrollY > onDetectScrollDirection.oldScrollY) {
    onDetectScrollDirection.oldScrollY = currentScrollY
    // if (callbacks.scrollDown !== undefined) callbacks.scrollDown()
    callbacks.scrollDown()

    return 'scrolling down'
  } else {
    onDetectScrollDirection.oldScrollY = currentScrollY
    // if (callbacks.scrollUp !== undefined) callbacks.scrollUp()
    callbacks.scrollUp()

    return 'scrolling up'
  }
}

/**
 * *onScrollHero
 */
let scrollTopCurrent = 0
let scrollPercentage = 100
let classDown = DEFAULT_INITIAL_SETTINGS.classNames.down
let classUp = DEFAULT_INITIAL_SETTINGS.classNames.up

export const onScrollHero = () => {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  let nodeHeader = onSelect(DEFAULT_INITIAL_SETTINGS.selectors.header)

  if (scrollTop > scrollPercentage) {
    if (scrollTop > scrollTopCurrent) {
      // down scroll
      onAdd(nodeHeader, classDown)
      onRemove(nodeHeader, classUp)
    } else {
      // up scroll
      onRemove(nodeHeader, classDown)
      onAdd(nodeHeader, classUp)
    }
  } else {
    onRemove(nodeHeader, classDown)
    onRemove(nodeHeader, classUp)
  }

  scrollTopCurrent = scrollTop <= 0 ? 0 : scrollTop
}

onScrollHero()
onDirectionScroll()
window.addEventListener('scroll', function () {
  onScrollHero()
  onDirectionScroll()
})

export { LENIS_SCROLL_GLOBAL, SCROLL_DIRECTION, onDetectScrollDirection }
